export const ADD_SERIES = "ADD_SERIES";
